import { render, staticRenderFns } from "./SimuladorOdontoModal.vue?vue&type=template&id=40afc3b8"
import script from "./SimuladorOdontoModal.vue?vue&type=script&lang=js"
export * from "./SimuladorOdontoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports